import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FilterControl} from '../interface/filter-control';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
// import { SetDataInUrlService } from '../service/set-data-in-url.service';
import {SetQuaryParamService} from '../service/set-query-param.service';
import {FabricFilterService} from '../service/fabric-filter.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';

@UntilDestroy()
@Component({
	selector: 'fb-filter-config-sidebar',
	templateUrl: './filter-config-sidebar.component.html',
	styleUrls: ['./filter-config-sidebar.component.scss'],
})
export class FilterConfigSidebarComponent {
	@Input() controls: FilterControl = {} as FilterControl;
	@Output() public onControlChange: EventEmitter<null> =
		new EventEmitter<null>();
	public route:string = '';
	public filterOpen: boolean = false;
	public isFabric: boolean  = true;
	public isSearchPage: boolean  = false;
	public isProductsFinished: boolean  = false;
	public productLength: number = 0;

	constructor(
		private _location: Location,
		private _activatedRoute: ActivatedRoute,
		private _setUrlParam: SetQuaryParamService,
		private fabricFilterService: FabricFilterService
	) {}

	public onChange(): void {
		this.onControlChange.emit(null);
	}

	public addParam(controls: FilterControl): void {}

	public readParam(urlString: Params): void {}

	public openFilter(): void {
		this.filterOpen ? (this.filterOpen = false) : (this.filterOpen = true);
	}

	public ngOnInit(): void {
		this._activatedRoute.params.subscribe((params: Params): void => {
			if (params['category'] === 'search') {
				this.isSearchPage = true;
			}

			this.isProductsFinished = params['category'] === 'finished';
		});



		this.fabricFilterService.filteredData.subscribe(
			(data: ProductListing[]): void => {
				this.productLength = data.length;
			}
		);
	}
}
